import React from "react";
import { useLocation } from "react-router-dom";
import { getCrumbs } from "../../utils/helpers";
import {
  BreadCrumbs,
  Content,
  Heading,
  MainSection,
  NavSection,
  Section,
  StyledNav,
} from "./PagesLayout.styles";

const PagesLayout = ({ children }) => {
  const { pathname } = useLocation();

  //programmatic breadcrumbs
  const { breadCrumbs, pageTitle, current } = getCrumbs(pathname);

  return (
    <Section>
      <NavSection bgColor="#f6f5ff">
        <Content>
          <Heading>{pageTitle}</Heading>
          <BreadCrumbs>
            {breadCrumbs.map(({ id, title, href }) => (
              <StyledNav key={id} to={href} className={title === current ? "current" : undefined}>
                {title}
              </StyledNav>
            ))}
          </BreadCrumbs>
        </Content>
      </NavSection>

      <MainSection bgColor="#fff">{children}</MainSection>
    </Section>
  );
};

export default PagesLayout;
